export const TEMPLATE_STEP = {
    ACTIVITY: "activity",
    RISKY_POSITION: "riskyPosition",
    PREREQUIS: "prerequis",
    LOCATION_SALARY: "locationSalary",
    INFO: "info",
    CONFIRMATION: "confirmation",
};

// Wizard order: the context's `templatePage` is the 1-based position in this list.
export const TEMPLATE_STEPS = [
    { key: TEMPLATE_STEP.ACTIVITY, defaultLabel: "Secteur d'activité" },
    { key: TEMPLATE_STEP.RISKY_POSITION, defaultLabel: "Poste à risque" },
    { key: TEMPLATE_STEP.PREREQUIS, defaultLabel: "Pré-requis" },
    { key: TEMPLATE_STEP.LOCATION_SALARY, defaultLabel: "Lieu & Rémunération" },
    { key: TEMPLATE_STEP.INFO, defaultLabel: "Informations supp." },
    { key: TEMPLATE_STEP.CONFIRMATION, defaultLabel: "Confirmation" },
];

export const TEMPLATE_STEPS_COUNT = TEMPLATE_STEPS.length;

export const getTemplateStepKey = (templatePage) =>
    TEMPLATE_STEPS[templatePage - 1]?.key;

export const getTemplateStepPage = (stepKey) =>
    TEMPLATE_STEPS.findIndex((step) => step.key === stepKey) + 1;

export const getTemplateStepLabel = (language, step) =>
    language.getValue(`missionTemplate.steps.${step.key}`, step.defaultLabel);
